(() => {
  if (window.AWP1LiteTracking?.version) return;

  const normalize = (value = '') => String(value).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  const themeRole = String(window.Shopify?.theme?.role || '').toLowerCase();
  const isPreview = Boolean(window.Shopify?.designMode || (themeRole && themeRole !== 'main') || /(?:\?|&)preview_theme_id=/.test(location.search) || /(?:\?|&)previewPath=/.test(location.search));

  const track = (name, payload = {}) => {
    const event = normalize(name);
    if (!event) return;
    const data = {
      schema_version: 1,
      path: location.pathname.slice(0, 180),
      locale: document.documentElement.lang || '',
      currency: window.Shopify?.currency?.active || '',
      preview_mode: isPreview,
      cluster: String(payload.cluster || '').slice(0, 120),
      href: String(payload.href || '').slice(0, 180),
      label: String(payload.label || '').slice(0, 120)
    };
    const eventName = `assassin_workshop:${event}`;
    window.dispatchEvent(new CustomEvent('aw:analytics', { detail: { event: eventName, payload: data, suppressed: isPreview } }));
    if (isPreview) return;
    const publish = (attempt = 0) => {
      try {
        if (window.Shopify?.analytics?.publish) {
          window.Shopify.analytics.publish(eventName, data);
          return;
        }
      } catch (_) { return; }
      if (attempt < 8) setTimeout(() => publish(attempt + 1), 250);
    };
    publish();
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: `aw_${event}`, ...data });
    } catch (_) {}
  };

  const cluster = (node) => node.dataset.awP1Cluster || node.closest?.('[data-aw-pdp-universe]')?.dataset.awPdpUniverse || '';
  const bind = (scope = document) => {
    scope.querySelectorAll?.('[data-aw-p1-track]:not([data-aw-p1-lite-bound])').forEach((node) => {
      node.dataset.awP1LiteBound = 'true';
      node.addEventListener('click', () => track(node.dataset.awP1Track || 'p1_click', {
        cluster: cluster(node),
        href: node.getAttribute('href') || '',
        label: (node.textContent || '').trim()
      }));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(), { once: true });
  else bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));

  window.AWP1LiteTracking = { version: '1.1.0', bind, track };
})();
